import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { logBuildInfo } from './buildInfo';
import { startVersionCheck } from './utils/versionCheck';
import { installFetchSessionGuard } from './utils/sessionExpiry';
import { registerServiceWorker } from './utils/registerServiceWorker';

// Same base URL services/api.js and the fetch-based screens use.
installFetchSessionGuard(process.env.REACT_APP_API_URL
  || 'https://previuagenticplatform-production.up.railway.app/api');

logBuildInfo();
startVersionCheck();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
